(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/leaguestatistics/assets/javascripts/models/statleaguestatistics.js') >= 0) return;  svs.modules.push('/components/statistics/leaguestatistics/assets/javascripts/models/statleaguestatistics.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  svs.statistics.models.StatLeagueStatistics = Backbone.Model.extend({
    players: [],
    teams: [],
    FETCH_LEAGUE: 'fetch_league',
    FETCH_TEAM: 'fetch_team',

    ASSISTS: 'Assists',
    GOALS: 'Mål',
    MATCHES_PLAYED: 'Antal matcher',
    STARTING_XI: 'Startat',
    SUBSTITUTIONS_IN: 'Antal byten in',
    SUBSTITUTIONS_OUT: 'Antal byten ut',
    YELLOW_CARDS: 'Gula kort',
    RED_CARDS: 'Röda kort direkt',
    YELLOW_OR_RED_CARDS: 'Gula/Röda kort',
    TOTAL_RED_CARDS: 'Röda kort',

    currentState: null,
    initialize: function() {
      this.setCurrentState(this.FETCH_LEAGUE);
      if (this.attributes.leagueId) {
        this.currentLeagueId = this.attributes.leagueId;
        if (this.attributes.league.underlyingLeagues) {
          this.attributes.league.underlyingLeagues = _.filter(
            this.attributes.league.underlyingLeagues,
            function(league) {
              return !league.isMultiTier;
            }
          );
          if (this.attributes.league.underlyingLeagues[0]) {
            this.currentLeagueId = this.attributes.league.underlyingLeagues[0].id;
          }
        }
      }
    },
    defaults: function() {
      if ((((svs.statistics || {}).data || {}).leagueModels || {}).statistics) {
        return this.parse(svs.statistics.data.leagueModels.statistics);
      }
    },
    url: function() {
      return this.validateState();
    },
    setCurrentState: function(sCurrentState) {
      this.currentState = sCurrentState;
    },
    getCurrentState: function() {
      return this.currentState;
    },
    validateState: function() {
      var execState = null;
      switch (this.getCurrentState()) {
        case this.FETCH_LEAGUE:
          execState = this.multifetchURL();
          break;
        case this.FETCH_TEAM:
          execState = this.singlefetchURL();
          break;
        default:
          throw Error('no matching state');
      }
      return execState;
    },
    multifetchURL: function() {
      this.shift = this.attributes.shift;
      this.path = '';
      this.path += this.leagueStatisticsPath();
      this.path += this.playerStatisticsPath();
      this.path += this.teamsByLeagueIdPath();
      var s =
        svs.core.jupiter.url() +
        '/multifetch?urls=' +
        encodeURIComponent(this.path);
      return s;
    },
    singlefetchURL: function() {
      this.shift = this.attributes.shift;
      this.path = '';
      this.path += this.teamStatisticsByTeamIdAndLeagueId();
      var s = svs.core.jupiter.url() + '/multifetch?urls=' + this.path;
      s = s.substring(0, s.length - 1);
      return s;
    },
    leagueStatisticsPath: function() {
      return '/sport/1/leagues/' + this.currentLeagueId + '/statistics|';
    },
    playerStatisticsPath: function() {
      var pathPart =
        '/sport/1/leagues/' + this.currentLeagueId + '/playerstatistics|';
      return pathPart;
    },
    teamsByLeagueIdPath: function() {
      var pathPart = '/sport/1/leagues/' + this.currentLeagueId + '/teams';
      return pathPart;
    },
    teamStatisticsByTeamIdAndLeagueId: function() {
      var pathPart =
        'sport/1/teams/' +
        this.currentTeamId +
        '/leaguestatistics?leagueid=' +
        this.currentLeagueId +
        '|';
      return pathPart;
    },
    parse: function(response) {
      var playerStats = [],
        teamStats = [];
      if (this.currentTeamId) {
        var teamRSP = null;
        if (((response || {}).responses || {})[0]) {
          teamRSP = response.responses[0];
          if (
            !(teamRSP.teamStatistics || {}).team ||
            !(teamRSP.teamStatistics || {}).season ||
            !(teamRSP.teamStatistics || {}).playerStatistics
          ) {
            return;
          }
        }

        if (
          teamRSP.teamStatistics.playerStatistics.keys.redCardsForTeam ||
          teamRSP.teamStatistics.playerStatistics.byKey.yellowOrRedcardsForTeam
        ) {
          teamRSP.teamStatistics.playerStatistics.keys.totalRedCardsForTeam =
            'Totalt antal röda kort';
          teamRSP.teamStatistics.playerStatistics.byKey.totalRedCardsForTeam = this.unionPlayerStats(
            teamRSP.teamStatistics.playerStatistics.byKey.redCardsForTeam || [],
            teamRSP.teamStatistics.playerStatistics.byKey
              .yellowOrRedcardsForTeam || []
          );
        }

        var _self = this;
        for (var i = 0; i < this.teams.length; i++) {
          if (this.teams[i].id === _self.currentTeamId) {
            this.teams[i] = {
              id: teamRSP.teamStatistics.team.id,
              name: teamRSP.teamStatistics.team.name,
              mediumName: teamRSP.teamStatistics.team.mediumName,
              shortName: teamRSP.teamStatistics.team.shortName,
              code: teamRSP.teamStatistics.team.code,

              season: teamRSP.teamStatistics.season,
              players: teamRSP.teamStatistics.playerStatistics.players,
              keys: this.translateKeys(
                teamRSP.teamStatistics.playerStatistics.keys
              ),
              byPlayer: teamRSP.teamStatistics.playerStatistics.byPlayer,
              byKey: teamRSP.teamStatistics.playerStatistics.byKey
            };
            break;
          }
        }
        playerStats.byTeam = this.teams;
        _.extend(this.get('playerStatistics'), playerStats);
        this.trigger('change', this);
        return;
      }
      var statisticsRSP = null;
      if (((response || {}).responses || {})[0]) {
        statisticsRSP = response.responses[0];
      }

      if (((statisticsRSP || {}).statistics || {}).goalStatistics) {
        teamStats = statisticsRSP.statistics.goalStatistics;
      }

      this.teams = this.parseTeamsByLeagueId(response);
      playerStats = this.parsePlayStatistics(response, this.teams);
      return { playerStatistics: playerStats, teams: teamStats };
    },
    parsePlayStatistics: function(response, teams) {
      var playerStatistics = false;
      var playerStatsByLeague = [];
      var _self = this;
      _.each(response.responses, function(multipart) {
        if (_.isObject(multipart) && multipart.error === null) {
          if (_.isObject(multipart.statistics)) {
            playerStatistics = multipart.statistics;
            if (_.isObject(playerStatistics.keys)) {
              if (
                playerStatistics.keys.redCardsInTournament ||
                playerStatistics.byKey.yellowOrRedcardsInTournament
              ) {
                playerStatistics.keys.totalRedCardsInTournament =
                  'Totalt antal röda kort';
                playerStatistics.byKey.totalRedCardsInTournament = _self.unionPlayerStats(
                  playerStatistics.byKey.redCardsInTournament || [],
                  playerStatistics.byKey.yellowOrRedcardsInTournament || []
                );
              }
              playerStatistics.keys = _self.translateKeys(
                playerStatistics.keys
              );
            }
            var players = playerStatistics.players;
            if (_.isObject(players)) {
              playerStatsByLeague = playerStatistics;
            }
          }
        }
      });
      var byTeamList = teams;
      byTeamList = _.sortBy(byTeamList, 'name');
      playerStatsByLeague.byTeam = byTeamList;
      return playerStatsByLeague;
    },
    parseTeamsByLeagueId: function(response) {
      var teamData = false;
      _.each(response.responses, function(multipart) {
        if (_.isObject(multipart) && multipart.error === null) {
          if (_.isArray(multipart.teams)) {
            teamData = multipart.teams;
          }
        }
      });
      return teamData;
    },
    translateKeys: function(keys) {
      var theKey = null;
      for (var i in keys) {
        if (Object.prototype.hasOwnProperty.call(keys, i)) {
          theKey = i;
          if (theKey === 'assistsForTeam' || theKey === 'assistsInTournament') {
            keys[i] = this.ASSISTS;
          } else if (
            theKey === 'goalsForTeam' ||
            theKey === 'goalsIntournament'
          ) {
            keys[i] = this.GOALS;
          } else if (
            theKey === 'matchesPlayedForTeam' ||
            theKey === 'matchesPlayedIntournament'
          ) {
            keys[i] = this.MATCHES_PLAYED;
          } else if (theKey === 'startingXI') {
            keys[i] = this.STARTING_XI;
          } else if (theKey === 'substitutionsIn') {
            keys[i] = this.SUBSTITUTIONS_IN;
          } else if (theKey === 'substitutionsOut') {
            keys[i] = this.SUBSTITUTIONS_OUT;
          } else if (
            theKey === 'yellowCardsForTeam' ||
            theKey === 'yellowCardsInTournament'
          ) {
            keys[i] = this.YELLOW_CARDS;
          } else if (
            theKey === 'redCardsForTeam' ||
            theKey === 'redCardsInTournament'
          ) {
            keys[i] = this.RED_CARDS;
          } else if (
            theKey === 'yellowOrRedcardsForTeam' ||
            theKey === 'yellowOrRedcardsInTournament'
          ) {
            keys[i] = this.YELLOW_OR_RED_CARDS;
          } else if (
            theKey === 'totalRedCardsForTeam' ||
            theKey === 'totalRedCardsInTournament'
          ) {
            keys[i] = this.TOTAL_RED_CARDS;
          }
        }
      }
      return keys;
    },
    unionPlayerStats: function(a, b) {
      var union = _.union(a, b);
      var groups = _(union).groupBy('playerId');
      var out = _(groups).map(function(g, key) {
        return {
          playerId: key,
          value: _(g).reduce(function(m, x) {
            return m + parseInt(x.value, 10);
          }, 0)
        };
      });
      return out;
    },
    setCurrentLeague: function(leagueId) {
      this.setCurrentState(this.FETCH_LEAGUE);
      var _self = this;
      this.currentLeagueId = leagueId;
      this.currentTeamId = null;
      this.fetch({
        success: function() {
          _self.trigger('change', _self);
        },
        error: function() {
          _self.set({ leagueTables: null });
          _self.trigger('change', _self);
        }
      });
    },
    setCurrentTeam: function(teamId) {
      this.setCurrentState(this.FETCH_TEAM);
      var _self = this;
      this.currentTeamId = teamId;
      this.fetch({
        error: function() {
          _self.trigger('change', _self);
        }
      });
    },
    dispose: function() {
      this.clear(true);
    }
  });
})(Backbone, _, svs);

 })(window);